import React from 'react';
import PropTypes from 'prop-types';
import { Page } from 'framework7-react';

import { BaThankYou, DonorThankYou, LoadingScreen } from './subviews';

const thankYouType = {
  admin: <BaThankYou />,
  agent: <BaThankYou />,
  donor: <DonorThankYou />
};

const ThankYou = ({ mode = 'agent', uploadMediaLoading = false }) => {
  const thankYouPage = thankYouType[mode] || <BaThankYou />;
  return <Page>{uploadMediaLoading ? <LoadingScreen /> : thankYouPage}</Page>;
};

ThankYou.propTypes = {
  mode: PropTypes.string,
  uploadMediaLoading: PropTypes.bool
};

export default ThankYou;
